import * as React from 'react';

import {Card} from '../../card/card';
import type {IconProps} from '../../icon/svg-icon-wrapper';
import {Stack} from '../../layout/stack/stack';
import {Body} from '../../typography/body';

import {Metric} from '../metric';
import type {MetricType} from '../metric';

export type FeatureStatsCardHeaderDetails = {
    title: string;
    icon: React.ComponentType<IconProps>;
};

export type FeatureStatsCardState = {
    shouldRender: () => boolean;
    content: React.ReactNode;
};

interface Props {
    headerDetails: FeatureStatsCardHeaderDetails;
    rows: MetricType[][];
    specialStates?: FeatureStatsCardState[];
}

export function FeatureStatsCard(props: Props) {
    const matchingSpecialState = props.specialStates?.find((state) => state.shouldRender());
    const Icon = props.headerDetails.icon;

    return (
        <Card hasBorder={true} fitHeight={true} borderRadius={8} className='full-width'>
            <div className='flex flex-dir-col gap-16 pad-16 full-width border-box full-height'>
                <Stack isHorizontal={true} spacing={8} alignItems='center'>
                    <Icon size={20} alignCenter={true} />
                    <Body color='dark' isBold={true}>
                        {props.headerDetails.title}
                    </Body>
                </Stack>
                {matchingSpecialState ? (
                    matchingSpecialState.content
                ) : (
                    <Stack spacing={16}>
                        {props.rows.map((row, rowIndex) => (
                            <Stack
                                key={rowIndex}
                                isHorizontal={true}
                                spacing={8}
                                justifyContent='space-between'
                            >
                                {row.map((metric, metricIndex) => (
                                    <Metric
                                        key={metricIndex}
                                        {...metric}
                                        isCentered={false}
                                        size='normal'
                                    />
                                ))}
                            </Stack>
                        ))}
                    </Stack>
                )}
            </div>
        </Card>
    );
}
